import { getPediatricIndicator } from './getAgeForPediatricIndicator';

export const determineCellClassName = (_, rowInfo, column) => {
  if (!rowInfo) return {};

  // Highlight "patientName" if the age is less than 18
  if (column.id === 'patientName') {
    const isAgeLessThan18 = getPediatricIndicator(
      rowInfo.original?.admission_date,
      rowInfo.original?.birth_date
    );

    if (isAgeLessThan18) {
      return {
        className: 'child',
      };
    }
  }

  // Highlight "current_cls" and "max_cls" if hasEndStageRenalDisease is true
  if (
    (column.id === 'current_cls' || column.id === 'max_cls') &&
    rowInfo.original?.hasEndStageRenalDisease
  ) {
    return {
      className: 'indicator-end-stage-disease',
    };
  }

  // Default: no special class name
  return {};
};
